import { render, staticRenderFns } from "./SidebarMenuItem.vue?vue&type=template&id=000ab8d3&scoped=true"
import script from "./SidebarMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarMenuItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SidebarMenuItem.vue?vue&type=style&index=0&id=000ab8d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000ab8d3",
  null
  
)

export default component.exports